import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import Routes from '../containers/Routes';
import { CookiesProvider } from 'react-cookie';
import ScrollToTop from '../components/Hoc/Scroll';
import { history } from '../helpers/routes';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, createStore, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';
import { syncHistoryWithStore } from 'react-router-redux';
import reducers from '../redux/reducers';

const devMode = window.devMode = (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1');
const reduxArgs = [thunkMiddleware];
let composeEnhancers = compose;

if (devMode) { // if we're running this app locally (non-production):
  if (
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) {
    composeEnhancers = composeWithDevTools({
      trace: true
    });
  } else reduxArgs.push(logger); // log mutations to console if redux dev tools aren't installed
}

const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
  applyMiddleware(...reduxArgs)
));

const syncedHistory = syncHistoryWithStore(history, store);

class App extends Component {
  render () {
    return (
      <Provider store={store}>
        <CookiesProvider>
          <Router history={syncedHistory}>
            <ScrollToTop>
              <Routes />
            </ScrollToTop>
          </Router>
        </CookiesProvider>
      </Provider>
    );
  }
}

export default App;
